import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronLargeTop"><Path d="M2.5 14.5L12 9.5L21.5 14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronLargeTop;
